import React from "react";
import "./homeSections.css";

const CategoriesIntro = () => {
  return (
    <section className="home-section categories-section">
      <div className="container">

        <h2>Explore Content Categories</h2>

        <p>
          ShareVideo brings together a wide variety of content formats and
          categories so viewers can easily discover videos, music, audio,
          and photo posts that match their interests. From entertainment
          to education, our platform supports diverse creative expression.
        </p>

        <div className="category-block">

          <h3>Entertainment & Comedy</h3>
          <p>
            Watch engaging entertainment videos, comedy sketches,
            creative storytelling, and short viral clips uploaded
            by talented creators.
          </p>

          <h3>Music & Songs</h3>
          <p>
            Discover music videos, devotional songs, dance performances,
            and audio-only tracks. Creators can upload both video songs
            and standalone audio content.
          </p>

          <h3>Short Videos</h3>
          <p>
            Explore short vertical videos designed for quick and engaging
            viewing. Shorts allow creators to share bite-sized content
            that is easy to watch and share.
          </p>

          <h3>Photo & Image Posts</h3>
          <p>
            Browse creative photo posts, artistic images, event highlights,
            and visual storytelling content shared by photographers
            and creators.
          </p>

          <h3>Education & Tutorials</h3>
          <p>
            Learn from educational videos, tutorials, informative
            explanations, and skill-based content uploaded by experts
            and educators.
          </p>

          <h3>Devotional & Cultural</h3>
          <p>
            Watch devotional songs, spiritual talks, and cultural
            performances that promote positive and meaningful
            content experiences.
          </p>

        </div>

      </div>
    </section>
  );
};

export default CategoriesIntro;